import { Box } from "@mui/material";
import MetaTags from "react-meta-tags";

import {
  CUSTOM_PANELS_TITLE,
  CUSTOM_PANELS_LINK_CANONICAL,
} from "helpers/metatags";

import { GetQuote } from "./components/GetQuote";
import { KeyFeatures } from "./components/KeyFeatures";
import { ServiceOffers } from "./components/ServiceOffers";
import { ServiceOptions } from "./components/ServiceOptions";
import { TopBanner } from "./components/TopBanner";

export const CustomPanelOfferings = () => (
  <Box component="article" width={1}>
    <MetaTags>
      <title>{CUSTOM_PANELS_TITLE}</title>
      <link rel="canonical" href={CUSTOM_PANELS_LINK_CANONICAL} />
    </MetaTags>

    <TopBanner />
    <KeyFeatures />
    <ServiceOffers />
    <ServiceOptions />
    <GetQuote />
  </Box>
);
